import  { getEndpoint, getHeaders } from "../../../helpers/endpoint";

export const GET_MPT_CLUBS = 'GET_MPT_CLUBS';
export const GET_MPT_CLUBS_SUCCESS = 'GET_MPT_CLUBS_SUCCESS';
export const GET_MPT_CLUBS_ERROR = 'GET_MPT_CLUBS_ERROR';

export const getMptClubs = (scope) => {
    return (dispatch, getState) => {
        dispatch({ type: GET_MPT_CLUBS, scope });

        fetch(getEndpoint('getMptClubs'), {
            method: 'GET',
            headers: getHeaders(getState().authentication)
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: GET_MPT_CLUBS_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successGetMptClubs(data, scope));
        })
            .catch((error, type = GET_MPT_CLUBS_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successGetMptClubs(response, scope) {
    return dispatch => {
        dispatch({
            type: GET_MPT_CLUBS_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            response,
            scope
        });
    };
}

export const EDIT_MPT_CLUB = 'EDIT_MPT_CLUB';
export const EDIT_MPT_CLUB_SUCCESS = 'EDIT_MPT_CLUB_SUCCESS';
export const EDIT_MPT_CLUB_ERROR = 'EDIT_MPT_CLUB_ERROR';

export const editMptClub = (payload, scope) => {
    return (dispatch, getState) => {
        const { clubName, file } = payload;
        let formData = new FormData();
        if (clubName) formData.append('clubName', clubName);
        if (file) formData.append('file', file);
        dispatch({ type: EDIT_MPT_CLUB, scope });
        fetch(getEndpoint('editMptClub', payload),  {
            method: 'PATCH',
            headers: getHeaders(getState().authentication),
            body: formData,
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: EDIT_MPT_CLUB_ERROR,
                error: data.error,
                payload,
                scope
            });
            else dispatch(successEditMptClub(data, scope));
        })
            .catch((error, type = EDIT_MPT_CLUB_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successEditMptClub(response, scope) {
    return dispatch => {
        dispatch({
            type: EDIT_MPT_CLUB_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            response,
            scope
        });
    };
}

export const POST_MPT_CLUB = 'POST_MPT_CLUB';
export const POST_MPT_CLUB_SUCCESS = 'POST_MPT_CLUB_SUCCESS';
export const POST_MPT_CLUB_ERROR = 'POST_MPT_CLUB_ERROR';

export const postMptClub = (payload, scope) => {
    return (dispatch, getState) => {
        const { clubName, file } = payload;
        let formData = new FormData();
        formData.append('clubName', clubName);
        formData.append('file', file);
        dispatch({ type: POST_MPT_CLUB, scope });
        fetch(getEndpoint('postMptClub', payload),  {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: formData,
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: POST_MPT_CLUB_ERROR,
                error: data.error,
                payload,
                scope
            });
            else dispatch(successPostMptClub(data, scope));
        })
            .catch((error, type = POST_MPT_CLUB_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successPostMptClub(response, scope) {
    return dispatch => {
        dispatch({
            type: POST_MPT_CLUB_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            response,
            scope
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/entities/mpt/clubs.js